import { COLORS } from 'Components/utils/color/colors';

const getNavPositionClasses = (navPosition) => {
  switch (navPosition) {
    case 'top':
      return {
        thRoot: 'flex flex-col',
        thControlsWrapper: 'flex gap-10 justify-end mb-5 order-first w-full',
        thControls: 'flex gap-5 self-center',
        thControl: '',
      };
    case 'side':
      return {
        thRoot: 'flex flex-row justify-between',
        thInner: 'flex-1',
        thControlsWrapper: 'flex gap-10',
        thControls: 'flex gap-5 items-center justify-between pointer-events-none',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto',
      };
    case 'center':
    default:
      return {
        thRoot: 'overflow-hidden relative',
        thControls:
          'absolute flex items-center justify-between inset-0 pointer-events-none w-full z-1',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto',
      };
  }
};

export const themes = {
  default: ({ navPosition }) => {
    return {
      ...getNavPositionClasses(navPosition),
      thControlColor: COLORS.TRANSPARENT,
      thContolTheme: 'ghost',
      thControlSize: 'h-24',
    };
  },
  calendar: ({ navPosition }) => {
    return {
      ...getNavPositionClasses(navPosition),
      thInner: 'md:px-50',
      thControlColor: COLORS.WHITE,
      thControlSize: '',
    };
  },
  tabs: ({ navPosition }) => {
    return {
      ...getNavPositionClasses(navPosition),
      thControlColor: COLORS.LIGHT_SAND,
      thControlSize: 'h-40',
    };
  },
  nav: () => {
    return {
      thRoot: 'bg-white isolate overflow-hidden px-50 relative',
      thControls: 'absolute flex inset-0 items-center justify-between pointer-events-none w-full',
      thInner: 'border-lightGrey border-l-1 border-r-1',
      thControl: 'text-16',
      thControlLeft: 'mr-auto pointer-events-auto',
      thControlRight: 'ml-auto pointer-events-auto',
      thControlSize: 'h-50',
      thControlColor: COLORS.TRANSPARENT,
      thContolTheme: 'ghost',
    };
  },
};
